/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customers",
	data() {
		return {
			customers: [],
			customerHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				},
				{
					text: "Email Address",
					field: "emailAddress"
				},
				{
					text: "Phone Number",
					field: "primaryTelephoneNumber"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				manageCustomerUsers: "manageCustomerUsers",
				manageAddresses: "manageAddresses",
				viewOrder: "viewOrder",
				viewOrderDelivery: "viewOrderDelivery",
				viewOrderCollection: "viewOrderCollection",
				viewVehicles: "viewVehicles",
				manageCredits: "manageCredits",
				viewCustomerDiscountGroups: "viewCustomerDiscountGroups",
				customerDocuments: "customerDocuments",
				viewAudit: "viewAudit",
				viewOrderAudit: "viewOrderAudit"
			},
			customerAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditCustomerModal",
				heading: "Add Customer"
			},
			customerViewAuditModal:{
				showModal: false,
				modalId: "customerViewAuditModal",
				heading: "Customer Audit",
				companyId: null
			},
			customerViewOrderAuditModal:{
				showModal: false,
				modalId: "customerViewOrderAuditModal",
				heading: "Order Audit",
				companyId: null
			},
			customerMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveCustomerModal",
				heading: "Mark Customer As Active/Inactive",
				isActive: null,
				companyId: null
			},
			selectCustomerOrderTypeModal:{
				showModal: false,
				modalId: "selectCustomerOrderTypeModal",
				heading: "Select Order Type",
				selectedCompany: null
			},
			customerDocumentsModal:{
				showModal: false,
				modalId: "customerDocumentsModal",
				heading: "Customer Documents",
				companyId: null
			},
            bulkTopUpModal: {
                showModal: false,
                modalId: "bulkCreditTopUpModal",
                heading: "Bulk Credit Top-Up"
            },
			customer:{
				firstName: null,
				lastName: null,
				emailAddress: null
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomers(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				createdFrom: this.filter.fromDateCreated,
				createdTo: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isCollectionCompany: true,
				isDeliveryCompany: true,
				isExTankCompany: true,
			};
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customers = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						var isSalesRepUser = permissionsHelper.checkIfUserHasPermission(permissionsHelper.role.salesRep);
						for(let i = 0; i < this.customers.length; i++){
							this.customers[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditCustomer"
								},
								{
									name: this.customers[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnCustomerMarkAsActiveInactive"
								},
								{
									name: isSalesRepUser ? "View Customer Users" : "Manage Customer Users",
									key: this.actionKeys.manageCustomerUsers,
									elementId: "btnCustomerManageCustomerUsers"
								},
								{
									name: isSalesRepUser ? "View Addresses" : "Manage Addresses",
									key: this.actionKeys.manageAddresses,
									elementId: "btnCustomerManageAddresses"
								},
								// {
								// 	name: "View Orders",
								// 	key: this.actionKeys.viewOrder,
								// 	elementId: "btnCustomerViewOrders"
								// },
								{
									name: "View Orders",
									key: this.actionKeys.viewOrder,
									elementId: "btnCustomerViewDeliveryOrders"
								},
								{
									name: isSalesRepUser ? "View Vehicles" : "Manage Vehicles",
									key: this.actionKeys.viewVehicles,
									elementId: "btnCustomerViewVehicles"
								},
								{
									name: isSalesRepUser ? "View Credits" : "Manage Credits",
									key: this.actionKeys.manageCredits,
									elementId: "btnCustomerManageCredits"
								},
								{
									name: "View Pricing",
									key: this.actionKeys.viewCustomerDiscountGroups,
									elementId: "btnCustomerViewCustomerDiscountGroups"
								},
								{
									name: "Documents",
									key: this.actionKeys.customerDocuments,
									elementId: "btnCustomerDocumentsAction"
								},
								{
									name: "View Customer Audit",
									key: this.actionKeys.viewAudit,
									elementId: "btnCustomerViewAudit"
								}
							];
							// if(this.customers[i].enableCollectionOrders){
							// 	this.customers[i].actions.push({
							// 		name: "View Collection Orders",
							// 		key: this.actionKeys.viewOrderCollection,
							// 		elementId: "btnCustomerViewCollectionOrders"
							// 	});
							// }
							// if(this.customers[i].enableDeliveryOrders){
							// 	this.customers[i].actions.push({
							// 		name: "View Delivery Orders",
							// 		key: this.actionKeys.viewOrderDelivery,
							// 		elementId: "btnCustomerViewDeliveryOrders"
							// 	});
							// }
						}
						this.customers = dataTableHelper.castFieldValues(this.customers);
						this.filterStateChanged = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setCustomerActionsAndTableHeadings(){
			this.actions = [
				{
					name: "Edit",
					key: this.actionKeys.edit
				},
				{
					name: "Mark As Active Or Inactive",
					key: this.actionKeys.markAsActiveInactive
				},
				{
					name: "Manage Customer Users",
					key: this.actionKeys.manageCustomerUsers
				},
				{
					name: "Manage Addresses",
					key: this.actionKeys.manageAddresses
				},
				{
					name: "View Orders",
					key: this.actionKeys.viewOrder
				},
				{
					name: "View Vehicles",
					key: this.actionKeys.viewVehicles
				},
				{
					name: "Manage Credits",
					key: this.actionKeys.manageCredits
				},
				// {
				// 	name: "View Customer Discount Groups",
				// 	key: this.actionKeys.viewCustomerDiscountGroups
				// }
			];
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getCustomers();
		},
		onDateFilterClearClick(){
			console.log("clear clicked");
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getCustomers();
		},
        showBulkImportModal(){
            console.log("showBulkImportModal");
            this.bulkTopUpModal.showModal = true;
        },
        onBulkImportModalClose(){
            console.log("bulk import modal closed");
            this.bulkTopUpModal.showModal = false;
        },
		onAddCustomerClick(){
			this.$router.push("/customers/addEditCustomer");
		},
		onCustomerActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.$router.push("/customers/addEditCustomer/" + actionAndData.data.companyId);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.customerMarkAsActiveInactiveModal.showModal = true;
					this.customerMarkAsActiveInactiveModal.companyId = actionAndData.data.companyId;
					this.customerMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.customerMarkAsActiveInactiveModal.heading = "Mark Customer As " + (this.customerMarkAsActiveInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.registeredCompanyName;
					break;
				case this.actionKeys.manageCustomerUsers:
					this.$router.push("/customers/customerUsers/" + actionAndData.data.companyId);
					break;
				case this.actionKeys.manageAddresses:
					this.$router.push("/customers/customerAddresses/" + actionAndData.data.companyId);
					break;
				case this.actionKeys.viewOrder:
					this.selectCustomerOrderTypeModal.showModal = true;
					this.selectCustomerOrderTypeModal.selectedCompany = actionAndData.data;
					this.selectCustomerOrderTypeModal.heading = "View Orders: Select Order Type - " + actionAndData.data.registeredCompanyName;
					break;
				case this.actionKeys.viewVehicles:
					this.$router.push("/customers/customerVehicles/" + actionAndData.data.companyId);
					break;
				case this.actionKeys.manageCredits:
					this.$router.push("/customers/transactionHistory/" + actionAndData.data.companyId);
					break;
				case this.actionKeys.viewCustomerDiscountGroups:
					this.$router.push("/customers/customerSpecialPricing/" + actionAndData.data.companyId);
					break;
				case this.actionKeys.customerDocuments:
					this.customerDocumentsModal.showModal = true;
					this.customerDocumentsModal.companyId = actionAndData.data.companyId;
					this.customerDocumentsModal.heading = "Customer Documents - " + actionAndData.data.registeredCompanyName;
					break;
					case this.actionKeys.viewAudit:
					this.customerViewAuditModal.showModal = true;
					this.customerViewAuditModal.companyId = actionAndData.data.companyId;
					this.customerViewAuditModal.heading = "Customer Audit - " + actionAndData.data.registeredCompanyName;
					break;
				case this.actionKeys.viewOrderAudit:
				this.customerViewOrderAuditModal.showModal = true;
				this.customerViewOrderAuditModal.companyId = actionAndData.data.companyId;
				this.customerViewOrderAuditModal.heading = "Order Audit - " + actionAndData.data.registeredCompanyName;
				break;				// }
				// case this.actionKeys.viewOrderCollection:
				// 	this.$router.push("/orders/collection/" + actionAndData.data.companyId);
				// 	break;
				// case this.actionKeys.viewOrderDelivery:
				// 	this.$router.push("/orders/delivery/" + actionAndData.data.companyId);
				// 	break;
			}
		},
		onCompanyAuditModalClosed(){
			this.customerViewAuditModal.showModal = false;
			this.customerViewAuditModal.companyId = null;
		},
		onCompanyOrderAuditModalClosed(){
			this.customerViewOrderAuditModal.showModal = false;
			this.customerViewOrderAuditModal.companyId = null;
		},
		onMarkUserActiveInactiveSelected(isActive){
			this.customerMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerMarkAsActiveInactiveModal.isActive", this.customerMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.customerMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				companyId: this.customerMarkAsActiveInactiveModal.companyId,
				isActive: markAsActive
			};
			customerService.markCompanyAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getCustomers();
						this.customerMarkAsActiveInactiveModal.showModal = false;
						this.customerMarkAsActiveInactiveModal.isActive = true;
						this.customerMarkAsActiveInactiveModal.companyId = null;
					}
					this.customerMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.customerMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFormModalSaveButtonClicked(){
			//save
			this.customerAddEditFormModal.isSaving = true;
			var self = this;
			setTimeout(function(){
				self.customerAddEditFormModal.isSaving = false;
				self.customerAddEditFormModal.showModal = false;
				console.log("customer", self.customer);
			}, 2000);
		},
		onSelectCustomerOrderModalClick(){
			this.selectCustomerOrderTypeModal.showModal = false;
		},
		onCustomerDocumentsModalClose(){
			this.customerDocumentsModal.showModal = false;
			this.customerDocumentsModal.companyId = null;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Customers");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Customers");
		}
	},
	mounted: function () {
		console.log("$route",this.$route);
		console.log("Current Route", this.$route.path);
		this.setBreadcrumbs();
		this.setCustomerActionsAndTableHeadings();
		this.getCustomers();
	}
};